// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"1f3a2121","2376":"4cddf068","5066":"57d5ace2","7945":"aec78970","8049":"be165270"}[chunkId] + ".css";
};